import React, { useRef, useState } from "react";
import { useAppContext } from "../../AppProvider";
import { BarcodeMovementsProvider } from "../IncomingGoodDetails/providers/BarcodeMovements";
import BarcodeMovements from "../IncomingGoodDetails/BarcodeMovements";
import InputIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { faBarcode } from "../../utilities/fontawesomeIcons";
import ButtonConfirm from "../../Components/Buttons/Confirm";

export const Barcodes: React.FC = () => {
  const { dictionary } = useAppContext();
  const [barcode, setBarcode] = useState("");
  const barcodeRef = useRef<HTMLInputElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <div
        className="d-grid grid-column mt-1"
        style={{
          gridTemplateColumns: `1fr 4fr`,
        }}
      >
        <div className="box-container">
          <label className="label-2">
            {dictionary.actions.search}{" "}
            {dictionary.products.barcode.toLowerCase()}
          </label>
          <InputIcon
            ref={barcodeRef}
            name="barcode"
            type="text"
            placeholder="xxxxx"
            icon={faBarcode}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                buttonRef.current?.click();
              }
            }}
          />
          <ButtonConfirm
            className="w-100 mt-2"
            icon={false}
            ref={buttonRef}
            onClick={() => {
              if (barcodeRef.current) {
                setBarcode(barcodeRef.current.value);
                barcodeRef.current.select();
              }
            }}
          >
            {dictionary.actions.search}
          </ButtonConfirm>
        </div>
        <div className="box-container">
          <BarcodeMovementsProvider barcode={barcode}>
            <BarcodeMovements />
          </BarcodeMovementsProvider>
        </div>
      </div>
    </>
  );
};

export default Barcodes;
